module.exports = new __parcel__URL__("remove_troop_button.82560c15.png").toString();